import React from 'react'
import { Layout } from '../layouts/Layout';
import { LabaRugi } from '../componen/LabaRugi'

export const LabaRugiPages = () => {
  return (
    <Layout>
      <LabaRugi />
    </Layout>
  )
}
